import { render, staticRenderFns } from "./IlluPedagogieDynamique.vue?vue&type=template&id=7d7b406e&"
import script from "./IlluPedagogieDynamique.vue?vue&type=script&lang=js&"
export * from "./IlluPedagogieDynamique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports